"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tokens = require("../tokens");

var _utils = require("../utils");

var textContrast = function textContrast(hexa) {
  var rgb = (0, _utils.setRGB)(hexa);
  var scale = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
  var isColorLight = scale > 127;
  return isColorLight ? _tokens.colors.babar1000 : _tokens.colors.babar0;
};

var _default = textContrast;
exports.default = _default;